export const parentTeacherConferenceDTOFields = {
    id: 'id',
    journalId: 'journalId',
    subject: 'subject',
    date: 'date',
    description: 'description',
    parents: 'parents',
} as const;
